<template>
  <div class="cards">
    <img src="./icons/empty-wallet.svg" alt="" />
    <p class="text-gray-500">You do not have a MuleEx wallet account yet.</p>
    <a
      href="#"
      class="flex gap-2 font-semibold text-primary-yellow cursor-pointer"
    >
      <span><img src="@/assets/images/icons/add.svg"/></span>
      <span>Generate a Wallet Account.</span></a
    >
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.cards {
  background: #ffffff;
  box-shadow: 0px 0px 20px 2px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  height: 70vh;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}
</style>
